import { useCookies } from 'react-cookie';

export default function Footer() {
  const [cookies, setCookie, removeCookie] = useCookies();

  function changeCountry(val) {
    setCookie("user_country", val, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });
  }

  return (
    <footer className="bg-gray-100 mt-20 text-sm">
      <div className="max-w-7xl mx-auto px-4 py-10 grid md:grid-cols-4 gap-8">
        <div className="space-y-1">
          <h4 className="font-semibold mb-3">Company Info</h4>
          <p>Here to support your boobs & budget</p>
          {/* <p>IntimatesByItee is a modern lingerie and intimate wear brand dedicated to making you feel confident, comfortable, and beautiful every day.</p> */}
          <p>From everyday essentials to statement lingerie pieces, we carefully curate styles that blend elegance, quality, and comfort — delivered straight to your doorstep.</p>
          <br/>
          {/* <a href='/about-us' className="underline text-sm text-[#7d5af6] cursor-pointer">Find out more about us</a> */}
        </div>

        <div className="space-y-1">
          <h4 className="font-semibold mb-3">Products</h4>
          <p>Underwear</p>
          <p>Sleepwear</p>
          <p>Loungewear</p>
          <p>Fashion Accessories</p>
        </div>

        <div className="space-y-1">
          <h4 className="font-semibold mb-2">Customer Care</h4>
          <p>hello@intimatesbyitee.com</p>
          <p>+234 813 883 7980</p>
          <p>E194 Road 3, Ikota Shopping complex, VGC, Lekki, Lagos, Nigeria.</p>
        </div>

        <div className="gap-y-1">
          <h4 className="font-semibold mb-2">Subscribe</h4>
          <input
            className="w-full p-2 border mb-2"
            placeholder="Your email"
          />
          <button className="bg-black text-white w-full py-2">
            Subscribe
          </button>
            <select value={cookies?.user_country} selected={cookies?.user_country} onChange={(e) => changeCountry(e.target.value)} className="block md:hidden border px-2 py-1 text-sm mt-5">
                <option value="">Default</option>
                <option value="US">Other Regions</option>
                <option value="NG">Nigeria</option>
            </select>
        </div>
      </div>
      <div className="flex w-full pt-2 pb-3 items-center justify-center">
        <p>© 2026 IntimatesByItee By Al Signa Limited. All Rights Reserved</p>
      </div>
    </footer>
  )
}
